import { render, staticRenderFns } from "./Props2.vue?vue&type=template&id=05546e2a&scoped=true&"
import script from "./Props2.vue?vue&type=script&lang=js&"
export * from "./Props2.vue?vue&type=script&lang=js&"
import style0 from "./Props2.vue?vue&type=style&index=0&id=05546e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05546e2a",
  null
  
)

export default component.exports